import React, { FC } from 'react';

const WarningIcon: FC = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_2749_25294)">
            <circle cx="12" cy="12" r="11.5" stroke="#FD6C52"/>
            <path d="M13.1852 7.09091L12.9775 14.7294H11.0279L10.8148 7.09091H13.1852ZM12.0027 18.1385C11.6511 18.1385 11.3493 18.0142 11.0971 17.7656C10.845 17.5135 10.7207 17.2116 10.7243 16.8601C10.7207 16.5121 10.845 16.2138 11.0971 15.9652C11.3493 15.7166 11.6511 15.5923 12.0027 15.5923C12.34 15.5923 12.6365 15.7166 12.8922 15.9652C13.1479 16.2138 13.2775 16.5121 13.2811 16.8601C13.2775 17.0945 13.2154 17.3093 13.0946 17.5046C12.9775 17.6964 12.823 17.8509 12.6312 17.968C12.4395 18.0817 12.2299 18.1385 12.0027 18.1385Z" fill="#FD6C52"/>
        </g>
        <defs>
            <clipPath id="clip0_2749_25294">
                <rect width="24" height="24" fill="white"/>
            </clipPath>
        </defs>
    </svg>
);

export default WarningIcon;
import React, { FC } from 'react';

const WarningIcon: FC = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_2749_25294)">
            <circle cx="12" cy="12" r="11.5" stroke="#FD6C52"/>
            <path d="M13.1852 7.09091L12.9775 14.7294H11.0279L10.8148 7.09091H13.1852ZM12.0027 18.1385C11.6511 18.1385 11.3493 18.0142 11.0971 17.7656C10.845 17.5135 10.7207 17.2116 10.7243 16.8601C10.7207 16.5121 10.845 16.2138 11.0971 15.9652C11.3493 15.7166 11.6511 15.5923 12.0027 15.5923C12.34 15.5923 12.6365 15.7166 12.8922 15.9652C13.1479 16.2138 13.2775 16.5121 13.2811 16.8601C13.2775 17.0945 13.2154 17.3093 13.0946 17.5046C12.9775 17.6964 12.823 17.8509 12.6312 17.968C12.4395 18.0817 12.2299 18.1385 12.0027 18.1385Z" fill="#FD6C52"/>
        </g>
        <defs>
            <clipPath id="clip0_2749_25294">
                <rect width="24" height="24" fill="white"/>
            </clipPath>
        </defs>
    </svg>
);

export default WarningIcon;
